export const image = {
  width: '100%',
};
